import React from "react";
import styles from './PriceRow.module.scss';
import {currencyValueToLabel, eCurrency} from 'gui/components/formikCurrencySelector';
import numeral from 'numeral';

export interface IPriceRowProps {
  label?: string;
  price?: number;
  currency?: number;

  hideWhenNoPrice?: boolean;

  className?: string;
  labelClassName?: string;
  priceClassName?: string;

}

const PriceRow = ({
                    hideWhenNoPrice,
                    label,
                    price,
                    currency,
                    ...props
                  }: IPriceRowProps) =>
  (hideWhenNoPrice && price <= 0) ?
    null : (
      <div className={`${styles.DetailRow} ${props.className}`.trim()}>
        <span className={props.labelClassName}>
          {label}:
        </span>
        <span className={props.priceClassName}>
          {numeral(price).format("0,0")} {currencyValueToLabel[currency]}
        </span>
      </div>
    );

PriceRow.defaultProps = {
  label: '',
  price: 0,
  currency: eCurrency.SHEKEL,
  hideWhenNoPrice: false,

  className: '',
  labelClassName: "",
  priceClassName: "",
};

export default React.memo(PriceRow);
